const targets = {
    listTitle: 'Targets',
    seeList: 'see list view',
    subTitle:
        'Top 10 druggable molecular targets in positive association with the patient’s molecular profile.',
    seeAll: 'See all molecular alterations',
    tableHeader: {
        target: 'Target',
        relatedDrivers: 'Related drivers',
        gts: 'GTS'
    },
    noDruggableTargetsFound:
        'No druggable targets were found for this patient.',
    generalErrors: {
        unknown: {
            title: 'Something went wrong',
            description:
                'Druggable targets could not be loaded from the server.'
        },
        accessDenied: {
            title: 'Access Denied',
            description: 'You have no permission to view druggable targets.'
        }
    }
}

export default targets
